<template>
  <div class="p-20">
    <ToDoNotesIconSection />
    <Survey class="mt-10" />
  </div>
</template>

<script>
import healthActionMixin from '@platform-shared/mixins/health-actions/healthActionMixin.js'
import Survey from './Survey.vue'
import ToDoNotesIconSection from '../ToDoNotesIconSection.vue'

export default {
  components: {
    ToDoNotesIconSection,
    Survey,
  },
  mixins: [healthActionMixin],
  data() {
    return {
      showingCompleted: false,
    }
  },

}
</script>